import getFurthestPosition from "./getFurthestPosition";
import {coveredSeconds} from "./watchedRanges";

// Seconds of a video the learner has actually watched, for progress %,
// the Watched/Completed status and the Watched time.
//
// Entries with watchedRanges count only stretches that played, so skipping
// to the end no longer marks a video watched (QA 2026-10-05). Entries written
// before watchedRanges existed keep the old furthest-position reading, so
// nobody loses a completion they already have; useSync seeds their ranges
// from that position on the next play.
const getWatchedProgress = (entry) => {
  if (Array.isArray(entry?.watchedRanges)) {
    return coveredSeconds(entry.watchedRanges);
  }
  return getFurthestPosition(entry);
};

export default getWatchedProgress;
